import { Component } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { DevImportComponent } from "./components/dev-import/dev-import.component";
import { DevExportComponent } from "./components/dev-export/dev-export.component";
import { DevCerrixroleComponent } from "./components/dev-cerrixrole/dev-cerrixrole.component";
import { DevPowerBIComponent } from "./components/dev-powerbi/dev-powerbi.component";
import { DevCodeExecutionComponent } from "./components/dev-code-executions/dev-code-executions.component";
import { DevActionsComponent } from "./components/dev-actions/dev-actions.component";
import { DevKeysComponent } from "./components/dev-keys/dev-keys.component";

@Component({
    selector: 'devmanagement',
    templateUrl: './devmanagement.component.html',
    styleUrls: ['./devmanagement.component.scss'],
    imports: [
        MenuSystemDirective,
        DevImportComponent,
        DevExportComponent,
        DevCerrixroleComponent,
        DevPowerBIComponent,
        DevCodeExecutionComponent,
        DevActionsComponent,
        DevKeysComponent,
    ]
})
export class DevManagementComponent {
    tab: TabModel;
}